// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Whiteboard area styling */
.whiteboard-Area {
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Align everything to the left */
    padding: 20px; /* Moves the whole whiteboard to the left */
    position: relative;
    margin-left: 300px;
  }
  
 
  .drawing-area canvas {
    border: 2px solid var(--gray-200);
    margin-top: 20px;
    width: 100%; /* Ensures it spans the width */
    height: 800px; /* Set height for better usability */
  }
  
  /* Text area styling below icons */
  .writetext textarea {
    border: 1px solid var(--gray-300);
    background-color: var(--gray-50);
    padding: 10px;
    font-size: 14px;
    color: var(--gray-800);
    resize: both;
    width: 300px; /* Default width */
    height: 100px; /* Default height */
  }
  
 
  .controls {
    display: flex;
    align-items: center; /* Align all items vertically */
    gap: 50px; /* Ensure consistent spacing between groups */
    margin-bottom: 20px; /* Add space below the controls */
    margin-top: 15px;
  }
  
  .draw-controls, .text-controls {
    display: flex;
    align-items: center; /* Align icons and labels vertically */
    gap: 20px; /* Add consistent spacing between items */
  }
  
  .controls label, .text-controls button, .text-controls label {
    font-size: 14px;
    color: var(--gray-800); /* Ensure text is consistent and visible */
    margin: 2px; /* Remove unnecessary margins */
  }
  
  .text-controls button {
    padding: 5px 10px;
    cursor: pointer;
    background-color: var(--gray-50);
    border: 1px solid var(--gray-300);
    border-radius: 4px;
  }
  
  .text-controls input {
    width: 60px; /* Set consistent width for inputs */
    text-align: center; /* Center-align input values */
  }
  
  button:hover {
    background-color: var(--gray-200); /* Add hover effect for better interactivity */
  }
  
  .heading-whiteborad{
     margin-left: 500px;
  }

  .toolbar {
    display: flex;
    justify-content: flex-start; /* Aligns buttons to the left side of the container */
    gap: 10px; /* Optional: Adds space between buttons */
    
  }
  
  .toolbar button {
    padding: 10px 20px; /* Optional: Adds padding for better button appearance */
    font-size: 16px; /* Optional: Adjust font size */
    cursor: pointer;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Whiteboard/Whiteboard.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,iCAAiC;IAC1D,aAAa,EACM,2CAA2C;IAC9D,kBAAkB;IAClB,kBAAkB;EACpB;;;EAGA;IACE,iCAAiC;IACjC,gBAAgB;IAChB,WAAW,EAAE,+BAA+B;IAC5C,aAAa,EAAE,oCAAoC;EACrD;;EAEA,kCAAkC;EAClC;IACE,iCAAiC;IACjC,gCAAgC;IAChC,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,YAAY,EAAE,kBAAkB;IAChC,aAAa,EAAE,mBAAmB;EACpC;;;EAGA;IACE,aAAa;IACb,mBAAmB,EAAE,+BAA+B;IACpD,SAAS,EAAE,6CAA6C;IACxD,mBAAmB,EAAE,iCAAiC;IACtD,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB,EAAE,sCAAsC;IAC3D,SAAS,EAAE,yCAAyC;EACtD;;EAEA;IACE,eAAe;IACf,sBAAsB,EAAE,0CAA0C;IAClE,WAAW,EAAE,+BAA+B;EAC9C;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,iCAAiC;IACjC,kBAAkB;EACpB;;EAEA;IACE,WAAW,EAAE,oCAAoC;IACjD,kBAAkB,EAAE,8BAA8B;EACpD;;EAEA;IACE,iCAAiC,EAAE,8CAA8C;EACnF;;EAEA;KACG,kBAAkB;EACrB;;EAEA;IACE,aAAa;IACb,2BAA2B,EAAE,qDAAqD;IAClF,SAAS,EAAE,yCAAyC;;EAEtD;;EAEA;IACE,kBAAkB,EAAE,wDAAwD;IAC5E,eAAe,EAAE,+BAA+B;IAChD,eAAe;EACjB","sourcesContent":["/* Whiteboard area styling */\n.whiteboard-Area {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; /* Align everything to the left */\n    padding: 20px;\n    margin-left: 50px; /* Moves the whole whiteboard to the left */\n    position: relative;\n    margin-left: 300px;\n  }\n  \n \n  .drawing-area canvas {\n    border: 2px solid var(--gray-200);\n    margin-top: 20px;\n    width: 100%; /* Ensures it spans the width */\n    height: 800px; /* Set height for better usability */\n  }\n  \n  /* Text area styling below icons */\n  .writetext textarea {\n    border: 1px solid var(--gray-300);\n    background-color: var(--gray-50);\n    padding: 10px;\n    font-size: 14px;\n    color: var(--gray-800);\n    resize: both;\n    width: 300px; /* Default width */\n    height: 100px; /* Default height */\n  }\n  \n \n  .controls {\n    display: flex;\n    align-items: center; /* Align all items vertically */\n    gap: 50px; /* Ensure consistent spacing between groups */\n    margin-bottom: 20px; /* Add space below the controls */\n    margin-top: 15px;\n  }\n  \n  .draw-controls, .text-controls {\n    display: flex;\n    align-items: center; /* Align icons and labels vertically */\n    gap: 20px; /* Add consistent spacing between items */\n  }\n  \n  .controls label, .text-controls button, .text-controls label {\n    font-size: 14px;\n    color: var(--gray-800); /* Ensure text is consistent and visible */\n    margin: 2px; /* Remove unnecessary margins */\n  }\n  \n  .text-controls button {\n    padding: 5px 10px;\n    cursor: pointer;\n    background-color: var(--gray-50);\n    border: 1px solid var(--gray-300);\n    border-radius: 4px;\n  }\n  \n  .text-controls input {\n    width: 60px; /* Set consistent width for inputs */\n    text-align: center; /* Center-align input values */\n  }\n  \n  button:hover {\n    background-color: var(--gray-200); /* Add hover effect for better interactivity */\n  }\n  \n  .heading-whiteborad{\n     margin-left: 500px;\n  }\n\n  .toolbar {\n    display: flex;\n    justify-content: flex-start; /* Aligns buttons to the left side of the container */\n    gap: 10px; /* Optional: Adds space between buttons */\n    \n  }\n  \n  .toolbar button {\n    padding: 10px 20px; /* Optional: Adds padding for better button appearance */\n    font-size: 16px; /* Optional: Adjust font size */\n    cursor: pointer;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
